document.addEventListener("DOMContentLoaded", () => {
  // Toggle dropdown
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-custom-qty-button]');
    
    if (button) {
      const select = button.closest('[data-custom-qty]');
      const parentActions = button.closest('.productitem--actions');

      const isOpen = select.classList.toggle('is-open');

      if (parentActions) {
        parentActions.style.overflow = isOpen ? 'visible' : '';
      }

      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }
  });


  // Option select
  document.addEventListener('click', (event) => {
    const option = event.target.closest('.custom-qty-select__option');
    if (!option) return;

    const select = option.closest('[data-custom-qty]');
    const label = select.querySelector('[data-custom-qty-label]');
    const input = select.querySelector('[data-custom-qty-value]');
    const button = select.querySelector('[data-custom-qty-button]');
    const options = select.querySelectorAll('.custom-qty-select__option');

    const value = option.dataset.value;

    // Update UI
    label.textContent = value;
    input.value = value;

    options.forEach((item) => {
      item.classList.remove('is-selected');
      item.setAttribute('aria-selected', 'false');
    });

    option.classList.add('is-selected');
    option.setAttribute('aria-selected', 'true');

    // Close dropdown
    select.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');

    // Trigger change
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });


  // Mouse leave (still needs per-item unless you want full delegation via mouseover)
  document.addEventListener('pointerout', (event) => {
    const productItem = event.target.closest('.productitem');
    if (!productItem) return;

    // Ignore movement within the same product item
    if (event.relatedTarget && productItem.contains(event.relatedTarget)) {
      return;
    }

    const select = productItem.querySelector('[data-custom-qty]');
    const button = select?.querySelector('[data-custom-qty-button]');
    const parentActions = button?.closest('.productitem--actions');

    select?.classList.remove('is-open');
    button?.setAttribute('aria-expanded', 'false');

    if (parentActions) {
      parentActions.style.overflow = '';
    }
  });

  const items = document.querySelectorAll('.product-gallery--media-thumbnail');
  let totalWidth = 0;

  items.forEach((ele, index) => {
    if (index < 3) {
      totalWidth += ele.offsetWidth;
    }
  });

  const showMoreMediaBtn = document.querySelector('#show-more-media__btn');
  if(showMoreMediaBtn) {
    showMoreMediaBtn.closest('.show-more-media__wrapper').style.setProperty('--left', `${totalWidth + 20}px`);
    showMoreMediaBtn.addEventListener('click', (e) => {
      document.querySelectorAll('.product-gallery--media-thumbnail.hidden').forEach(ele => {
        ele.classList.toggle('hidden');
      })
      e.currentTarget.classList.add('hidden');
    })
  }

  document.addEventListener("change", function (e) {
    const target = e.target;

    const select = target.closest(".productitem--actions .form-field-select");
    const input = target.closest(".productitem--actions .form-field-number");

    if (!select && !input) return;

    const parent = (select || input).closest(".productitem--actions");
    if (!parent) return;

    const btnAtc = parent.querySelector("[data-quick-buy]");
    if (!btnAtc) return;

    // Use whichever triggered the event
    const value = select ? select.value : input.value;

    btnAtc.setAttribute("data-quantity", value);
  });

  document.addEventListener('change', (event) => {
    const target = event.target;

    // SELECT
    if (target.matches('[data-quantity-select]')) {
      const select = target;
      const wrapper = select.closest('[data-quantity-wrapper]');

      if (!wrapper) return;

      const input = wrapper.querySelector('[data-quantity-input]');
      const inputParent = wrapper.querySelector('.form-field--qty-input');
      const selectParent = wrapper.querySelector('.form-field--qty-select');

      const value = validateValue(select.value);

      // Sync input with select
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      if (value >= 10) {
        inputParent.classList.remove('hidden');
        inputParent.classList.add('visible');

        selectParent.classList.remove('visible');
        selectParent.classList.add('hidden');

        input.removeAttribute('tabindex');
        input.focus();
        input.select();

        select.setAttribute('tabindex', '-1');
      }
    }

    // INPUT
    if (target.matches('[data-quantity-input]')) {
      target.value = validateValue(target.value);
    }
  });

  function validateValue(value) {
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? 1 : parsed;
  }

  const limiter = document.querySelectorAll('.limiter');
  limiter.forEach(ele => { 
    ele.addEventListener('change', (e) => {
      const value = e.target.value;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            product_list_limit: value
          }
        })
      })
      .then(res => res.json())
      .then(data => {
        const url = new URL(window.location.href);
        url.searchParams.delete('page');
        window.history.replaceState({}, '', url.toString());
        location.reload();
      });
    })
  })

  const productSeries = document.querySelector('[data-product-series]');
  const tabSeries = document.querySelectorAll('.tab-series');

  if(productSeries && tabSeries) {
    productSeries.addEventListener('click', (e) => {
      e.preventDefault();
      tabSeries.forEach(ele => {
        ele.click();
        ele.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
      })
    })
  }

  const requetQuoteBtn = document.querySelectorAll(".request-quote--btn");
  const closeBtn = document.querySelector(".request-quote-form__close-btn");
  const requetQuoteForm = document.querySelector("#request-quote-form");
  const body = document.querySelector("body");

  function openModal() {
    requetQuoteForm.classList.add('open');
    body.classList.add("overflow-hidden");
    document.addEventListener('click', handleOutsideClick);
  }

  function closeModal() {
    requetQuoteForm.classList.remove('open');
    body.classList.remove("overflow-hidden");
    document.removeEventListener('click', handleOutsideClick);
    const message = requetQuoteForm.querySelector('.contact-message.message--success');
    if(message) {
      requetQuoteForm.querySelector('.contact-message.message--success').remove();
    }
    
    requetQuoteForm.querySelector('#RequestQuoteForm').reset();
  }

  function handleOutsideClick(e) {
    const wrapper = requetQuoteForm.querySelector('.request-quote-form__wrapper');

    const isClickInside = wrapper?.contains(e.target);
    const isOpenBtn = Array.from(requetQuoteBtn).some(btn => btn?.contains(e.target));

    if (!isClickInside && !isOpenBtn) {
      closeModal();
    }
  } 

  if(requetQuoteBtn) {
    requetQuoteBtn.forEach(btn => btn.addEventListener("click", openModal));
  }
  if( closeBtn) {
    closeBtn.addEventListener("click", closeModal);
  }

  // const _handleDocumentClick = (e) => {
  //   const form = document.querySelector("#RequestQuoteForm").closest('.request-quote-form__wrapper');
  //   const isClickInside = form.contains(e.target);
  //   const isOpenBtn = requetQuoteBtn.contains(e.target);

  //   if (!isClickInside && !isOpenBtn) {
  //     closeModal();
  //   }
  // };

  //Add to online quote
  const generateId = () => `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".quotation-btn");
    if (!btn) return;
  
    const productsOnlineQuote = JSON.parse(localStorage.getItem('online_quote')) || [];
    const parent = e.target.closest(".productgrid--item") || e.target.closest(".product--section");
    const productEl = parent.querySelector('[data-product-data]') || parent.querySelector('[data-section-data]');
    const productMetafieldsEl = parent.querySelector('[data-product-metafields]') || parent.querySelector('[data-section-data]');

    
    if (!productEl) return;
  
    const json = JSON.parse(productEl.textContent);
    const metafields = JSON.parse(productMetafieldsEl.textContent);
    const sku = json?.variants?.[0]?.sku || json?.product?.variants?.[0]?.sku;
    
    if (!sku) return;

    const existingIndex  = productsOnlineQuote.findIndex(item => item.sku === sku);
      if (existingIndex !== -1) {
      productsOnlineQuote[existingIndex].quantity += 1;
    } else {
      productsOnlineQuote.push({
        id: generateId(),
        sku: sku,
        metafields: metafields.metafields,
        quantity: 1
      });
    }
    localStorage.setItem('online_quote', JSON.stringify(productsOnlineQuote));
    location.href = '/pages/online-quote';
  });
})


class AddToCartFlyout1 {
  constructor() {
    this.formData = {};
    this.settings = {};
    this.events = [];
    this.flyOutSelector = '[data-atc-banner]';
    this.$atcTemplate = document.querySelector(`[data-templates] ${this.flyOutSelector}`);
    this.activeElement = null;

    this.atcFlyOut = document.querySelector(this.flyOutSelector);

    this._onInit = this._onInit.bind(this);
    this._onError = this._onError.bind(this);
    this._onSuccess = this._onSuccess.bind(this);
    this._onCloseAll = this._onCloseAll.bind(this);
    this._handleDocumentClick = this._handleDocumentClick.bind(this);

    this._closeEsc = this._closeEsc.bind(this);

    this.header = document.querySelector('[data-site-header]');
    this.headerMain = this.header?.querySelector('[data-site-header-main]');
    this.body = document.body;
  }

  init(formData, product, options, callbacks = {}, recipientForm) {
    this.formData = formData;
    this.product = product;
    this.recipientForm = recipientForm;

    // Allows ATC Flow to be overridden
    this.callbacks = {
      onInit: this._onInit,
      onError: this._onError,
      onSuccess: this._onSuccess,
      onClose: this._onCloseAll,
      ...(callbacks || {}),
    };

    const atcButton =
      options.atcButton ||
      (options.atcButton instanceof Element
        ? options.atcButton
        : typeof options.atcButton === 'string'
          ? document.querySelector(options.atcButton)
          : null);

    this.settings = {
      moneyFormat: null,
      cartRedirection: false,
      ...(options.settings || {}),
    };

    // If any FlyOuts are fully open, close them
    this._closeFlyOuts();

    this.callbacks.onInit?.();

    this.activeElement = document.activeElement;

    if (atcButton) {
      this._disableButton(atcButton);
      this._updateCart(atcButton);
    }
  }

  unload() {
    this._removeFlyOuts();
  }

  async _updateCart(atcButton) {
    const flyOut = this.$atcTemplate.cloneNode(true);
    const id = parseInt(this.formData.id);
    const variants = this.product.variants.filter(variant => variant.id === id);
    const variant = variants[0];

    try {
      // ADD TO CART
      const addRes = await fetch(`${window.Theme.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.formData),
      });

      const response = await addRes.json();
      this.itemId = response.id;

      window.api.theme.triggerEvent('cart:updated', { cancel: () => {} });

      if (this.settings.cartRedirection) {
        location.href = window.Theme.routes.cart_url;
        return;
      }

      // IMAGE
      if (response.image) {
        const imgWrap = flyOut.querySelector('[data-atc-banner-product-image]');
        if (imgWrap) {
          imgWrap.innerHTML = `<img src="${response.image}" alt="${response.title}">`;
        }
      }

      // TITLE
      const el = flyOut.querySelector('[data-atc-banner-product-title]');
      if (el) {
        el.textContent = response.title;
      }

      // OPTIONS
      if (
        response.variant_options?.[0] !== 'Title' &&
        response.variant_options?.[0] !== 'Default Title'
      ) {
        const productOptions = flyOut.querySelector('[data-atc-banner-product-options]');
        if(productOptions) {
          productOptions.textContent = response.variant_options.join(', ');
        }
      }

      // PRICE + QUANTITY
      const productPriceQuantity = flyOut.querySelector('[data-atc-banner-product-price-quantity]');
      if (productPriceQuantity) {
        productPriceQuantity.textContent = `${response.quantity} × `;
      }

      const productPriceValue = flyOut.querySelector('[data-atc-banner-product-price-value]');
      if (productPriceValue && variant) {
        productPriceValue.textContent =
          Shopify.formatMoney(variant.price, this.settings.moneyFormat);
      }

      // UNIT PRICE
      const unitPrice = flyOut.querySelector('[data-atc-banner-unit-price]');
      if (unitPrice && variant?.unit_price_measurement) {
        let unitPriceString = unitPrice.innerHTML;

        const m = variant.unit_price_measurement;

        unitPriceString = unitPriceString
          .replace('** total_quantity **', `${m.quantity_value}${m.quantity_unit}`)
          .replace('** unit_price **', Shopify.formatMoney(variant.unit_price, this.settings.moneyFormat))
          .replace(
            '** unit_measure **',
            m.reference_value === 1
              ? m.reference_unit
              : `${m.reference_value}${m.reference_unit}`
          );

        unitPrice.innerHTML = unitPriceString;
        unitPrice.classList.remove('hidden');
      }

      // GET CART
      const cartRes = await fetch(`${window.Theme.routes.cart_url}.js`);
      const cart = await cartRes.json();

      this.callbacks.onSuccess?.();
      this.formData = {};

      // SUBTOTAL LISTENER
      const subTotal = flyOut.querySelector('[data-atc-banner-cart-subtotal]');

      const cartTotalValueListener = ({ price }) => {
        if (subTotal) {
          subTotal.innerHTML = Shopify.formatMoney(price, this.settings.moneyFormat);
        }
      };

      this.cartTotalValue = window.api.theme.useValue({
        name: 'cart:total',
        handler: cartTotalValueListener,
        initialValue: {
          price: cart.total_price,
          compare_at_price: cart.total_price,
        },
      });

      // CART COUNT
      const cartBtnSpan = flyOut.querySelector('[data-atc-banner-cart-button] span');

      if (cartBtnSpan) {
        cartBtnSpan.textContent = cart.item_count;
      }

      // APPEND
      this.header.appendChild(flyOut);

      this.headerMain.dispatchEvent(
        new CustomEvent('cartcount:update', { detail: { response: cart } })
      );

      if (this.headerMain && window.jQuery) {
        window.jQuery(this.headerMain).trigger('cartcount:update', {
          response: cart
        });
      }

      this._bindEvents(flyOut);
      this._openFlyOut(flyOut, atcButton);
      this._enableButton(atcButton);

      if (errorText.email) {
        this.recipientForm.classList.add('recipient-form--has-errors');
      } else {
        this.callbacks.onError(errorText);
      }
      
    } catch (err) {
      let errorText;

      try {
        const json = await err?.json?.();
        errorText = json?.description;
      } catch {
        errorText = err?.status
          ? `${err.status} ${err.statusText}`
          : 'Unknown error';

        if (err?.status === 401) {
          errorText += '. Try refreshing and logging in.';
        }
      }
    }
  }

  _onError(error) {
  }

  _onInit() {

  }

  _onSuccess() {
    /*
      By default, the ATC Flyout doesn't need any additional success callbacks

      The `this.callbacks.onSuccess` is used to allow other views to initiate
      behaviour when a product has been added to the cart
     */
  }

  _onCloseAll() {
    /*
      By default, the ATC Flyout doesn't need any additional close callbacks

      The `this.callbacks.onClose` is used to allow other views to initiate
      behaviour when the atc banner has been closed
     */
  }

  _bindEvents(flyOut) {
    const closeBtn = flyOut.querySelector('[data-atc-banner-close]');
    const checkoutBtn = flyOut.querySelector('[data-atc-button-checkout]');

    const handleClose = (e) => {
      e.preventDefault();
      this._closeFlyOut(flyOut);
    };

    const handleCheckout = (e) => {
      window.api.theme.triggerEvent('cart:checkout', {
        cancel: () => e.preventDefault()
      });
    };

    closeBtn?.addEventListener('click', handleClose);
    checkoutBtn?.addEventListener('click', handleCheckout);

    this.events.push(
      { el: closeBtn, type: 'click', handler: handleClose },
      { el: checkoutBtn, type: 'click', handler: handleCheckout }
    );
  }

  _unbindEvents() {
    this.events.forEach(({ el, type, handler }) => {
      el?.removeEventListener(type, handler);
    });
    this.events = [];
  }

  _closeFlyOuts(excludeFlyOut = null) {
    const flyOuts = document.querySelectorAll(this.flyOutSelector);

    flyOuts.forEach((el, index) => {
      if (!el.hasAttribute('data-flyout-active')) return;

      if (excludeFlyOut && el === excludeFlyOut) return;

      this._closeFlyOut(el, index);
    });

    if (!excludeFlyOut) {
      this.callbacks.onClose?.();
    }

    window.removeEventListener('keydown', this._closeEsc);
    window.removeEventListener('click', this._handleDocumentClick);
  }

  _openFlyOut(flyOut, atcButton) {
    this._closeFlyOuts(flyOut);

    flyOut.classList.add('animating', 'animating-in');

    let called = false;

    const done = () => {
      if (called) return;
      called = true;

      flyOut.classList.remove('animating', 'animating-in');
      flyOut.classList.add('visible');
      flyOut.setAttribute('data-flyout-active', 'true');

      window.addEventListener('keydown', this._closeEsc);
      window.addEventListener('click', this._handleDocumentClick);

      this._enableButton(atcButton);
    };

    const handleTransitionEnd = (e) => {
      if (e.target !== flyOut) return;

      flyOut.removeEventListener('transitionend', handleTransitionEnd);
      done();
    };
    flyOut.addEventListener('transitionend', handleTransitionEnd);
    setTimeout(done, 400);

    flyOut.classList.add('animating', 'animating-in');
  }

  _closeEsc = (e) => {
    if (e.key === 'Escape') {
      this._closeFlyOuts();
    }
  };


  _closeFlyOut(flyOut = null, index = 0) {
    if (!flyOut) return;

    let called = false;

    const done = () => {
      if (called) return;
      called = true;

      flyOut.classList.remove('animating', 'animating-out', 'visible');

      this._removeFlyOut(flyOut, index);

      if (
        this.documentClickEventTarget &&
        this.documentClickEventTarget.dataset?.liveSearchInput !== undefined
      ) {
        this.documentClickEventTarget.focus();
      }

      this.callbacks.onClose?.();
    };

    const handleTransitionEnd = (e) => {
      if (e.target !== flyOut) return;
      flyOut.removeEventListener('transitionend', handleTransitionEnd);
      done();
    };

    flyOut.addEventListener('transitionend', handleTransitionEnd);

    setTimeout(done, 400); // match with CSS duration

    flyOut.classList.add('animating', 'animating-out');
  }

  _removeFlyOuts() {
    document
      .querySelectorAll(this.flyOutSelector)
      .forEach((el, index) => {
        if (el.hasAttribute('data-flyout-active')) {
          this._removeFlyOut(el, index);
        }
      });
  }
  
  _removeFlyOut(flyOut, index) {
    // Remove events
    this._unbindEvents();

    // Remove cart listener
    if (this.cartTotalValue) {
      this.cartTotalValue.unload();
      this.cartTotalValue = null;
    }

    // Remove DOM
    flyOut?.remove();
  }

  _disableButton(atcButton) {
    if (!atcButton) return;

    atcButton.classList.add('processing');
    atcButton.disabled = true;
  }
  _enableButton(atcButton) {
    if (!atcButton) return;

    atcButton.disabled = false;
    atcButton.classList.remove('processing');
  }

  _handleDocumentClick = (event) => {
    const target = event.target;

    const parent = target.closest('[data-atc-banner]');
    if (parent) return;

    this.documentClickEventTarget = target;
    this._closeFlyOuts();
  };
}

// expose global
window.AddToCartFlyout1 = new AddToCartFlyout1();

class ProductsList extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.btnsAtc = this.querySelectorAll('[data-quick-buy]');

    this.btnsAtc.forEach(btn => {
      btn.addEventListener('click', this._addToCart.bind(this));
    });
  }

  _addToCart(e) {
    const btn = e.target.closest('[data-quick-buy]');
    if (!btn) return;

    const parent = btn.closest('.productgrid--item');
    const productEl = parent?.querySelector('[data-product-data]');
    const product = productEl ? JSON.parse(productEl.textContent) : null;
    const settingsEl = parent?.querySelector('[data-quick-buy-settings]');
    const settings = settingsEl ? JSON.parse(settingsEl.textContent) : null;


    const quantity = btn.getAttribute('data-quantity');
    const variantId = btn.getAttribute('data-variant-id');

    if (!variantId) return;

    const formData = {
      'id': variantId,
      'quantity': quantity
    };

    window.AddToCartFlyout1.init(formData, product, {
      atcButton: btn,
      settings: settings
    })
    setTimeout(() => {
      parent.querySelector('select[name="product-item--quantity"]').value = 1;
    }, 1000)
  }
}

customElements.define('products-list', ProductsList);

document.addEventListener('DOMContentLoaded', () => {
  const stopThumbScrollFlick = () => {
    document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
      const scroller = gallery.querySelector('[data-gallery-scroller]');
      if (!scroller || scroller.dataset.noFlickPatched) return;

      scroller.dataset.noFlickPatched = 'true';

      scroller.addEventListener('click', event => {
        const thumb = event.target.closest('[data-gallery-thumbnail]');
        if (!thumb) return;

        const lockedScrollLeft = scroller.scrollLeft;

        requestAnimationFrame(() => {
          scroller.scrollLeft = lockedScrollLeft;

          requestAnimationFrame(() => {
            scroller.scrollLeft = lockedScrollLeft;
          });
        });
      }, true);
    });
  };

  stopThumbScrollFlick();

  document.addEventListener('shopify:section:load', stopThumbScrollFlick);
});
